import React from "react";
import ReactDOM from "react-dom";

import "./Modal.scss";

const Modal = ({ opened, close, children }) => {
    return ReactDOM.createPortal(
        <div
            className="modal"
            style={{
                opacity: opened ? "1" : "0",
                visibility: opened ? "visible" : "hidden"
            }}
            onClick={close}
        >
            {children}
        </div>,
        document.getElementById("root-modal")
    );
};

export default Modal;
